export default "__VITE_ASSET__HdJQiL4M__"